export default __webpack_public_path__ + "static/media/colman_thumb.fb576dbd.jpg";